import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { OnsiteInterviewAdapters } from '../adapters';
import { IGetOnsiteInterviewListApiResponse, IGetOnsiteInterviewListPayload } from '../types';

export const getOnsiteInterviewList = async (
  payload: IGetOnsiteInterviewListPayload,
): Promise<IGetOnsiteInterviewListApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IGetOnsiteInterviewListApiResponse>(
    `/offices/postings/${payload.jobPostingId}/onsite-interviews`,
    {
      headers,
      params: OnsiteInterviewAdapters.toGetOnsiteInterviewListApiQueryParams(payload),
    },
  );

  return response.data;
};
